export default "__VITE_ASSET__DGUtEjbE__"